module.exports = __webpack_public_path__ + "static/img/20200927144025.e139579a.gif";